module.exports = __webpack_public_path__ + "img/XGLHC.png";